export interface JWTPayload {
  iat: number;
  exp: number;
  roles: string[];
  username: string;
  user: {
    id: number;
    email: string;
    roles: string[];
    userGroups: any[];
    firstName: string;
    lastName: string;
    admin: boolean;
    clientAdmin?: boolean;
    timezone?: string;
    locale?: string;
  };
  tenant: {
    id: number;
    code: string;
    company_name: string;
  };
}

export const decodeJWT = (token: string): JWTPayload | null => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const getTenantIdFromToken = (token: string): number | null => {
  const payload = decodeJWT(token);
  return payload?.tenant?.id ?? null;
};
